document.addEventListener('DOMContentLoaded', function () {


 function getImages() {
   return Array.from(document.querySelectorAll('.product__media-item:not(.product__media-item--variant) img'))
     .map(img => img.src.replace(/width=\d+/, 'width=1445'));
 }


 function openLightbox(startIndex) {
   const images = getImages();
   if (!images.length) return;
   let current = startIndex || 0;
   let zoomed = false;


   const existing = document.getElementById('custom-lightbox');
   if (existing) existing.remove();


   // Build with full inline styles - no reliance on CSS
   const lb = document.createElement('div');
   lb.id = 'custom-lightbox';
   lb.setAttribute('style', [
     'position:fixed',
     'top:0','left:0','right:0','bottom:0',
     'width:100%','height:100%',
     'z-index:2147483647',
     'display:flex',
     'align-items:center',
     'justify-content:center',
     'background:rgba(255,255,255,0.95)'
   ].join(';'));


   const imgEl = document.createElement('img');
   imgEl.setAttribute('style', [
     'max-width:80vw','max-height:80vh',
     'object-fit:contain',
     'transition:transform 0.3s ease',
     'cursor:zoom-in',
     'position:relative',
     'z-index:2'
   ].join(';'));


   const btnStyle = [
     'position:fixed',
     'background:rgba(255,255,255,0.9)',
     'border:none',
     'border-radius:50%',
     'width:48px','height:48px',
     'font-size:22px',
     'cursor:pointer',
     'z-index:2147483647',
     'display:flex',
     'align-items:center',
     'justify-content:center',
     'box-shadow:0 2px 8px rgba(0,0,0,0.3)'
   ].join(';');


   const closeBtn = document.createElement('button');
   closeBtn.innerHTML = '✕';
   closeBtn.setAttribute('style', btnStyle + ';top:20px;right:20px;width:44px;height:44px;font-size:18px;');


   const prevBtn = document.createElement('button');
   prevBtn.innerHTML = '&#8592;';
   prevBtn.setAttribute('style', btnStyle + ';left:20px;top:50%;transform:translateY(-50%);');


   const nextBtn = document.createElement('button');
   nextBtn.innerHTML = '&#8594;';
   nextBtn.setAttribute('style', btnStyle + ';right:20px;top:50%;transform:translateY(-50%);');


   const zoomBtn = document.createElement('button');
   zoomBtn.innerHTML = '🔍';
   zoomBtn.setAttribute('style', btnStyle + ';bottom:24px;right:20px;width:44px;height:44px;font-size:16px;');


   const counter = document.createElement('div');
   counter.setAttribute('style', [
     'position:fixed',
     'bottom:24px','left:50%',
     'transform:translateX(-50%)',
     'color:#fff',
     'font-size:14px',
     'font-weight:500',
     'z-index:2147483647'
   ].join(';'));


   lb.appendChild(imgEl);
   lb.appendChild(closeBtn);
   lb.appendChild(prevBtn);
   lb.appendChild(nextBtn);
   lb.appendChild(zoomBtn);
   lb.appendChild(counter);
   document.body.appendChild(lb);
   document.body.style.overflow = 'hidden';


   function show(idx) {
           translateX = 0;
   translateY = 0;


     current = (idx + images.length) % images.length;
     imgEl.src = images[current];
     imgEl.style.transform = 'scale(1)';
     zoomed = false;
     counter.textContent = (current + 1) + ' / ' + images.length;
   }


   function close() {
     lb.remove();
     document.body.style.overflow = '';
   }


   closeBtn.onclick = close;
   lb.addEventListener('click', function(e) { if (e.target === lb) close(); });
   prevBtn.onclick = () => show(current - 1);
   nextBtn.onclick = () => show(current + 1);
       // Zoom + drag to pan
   let isDragging = false;
   let dragStartX, dragStartY, translateX = 0, translateY = 0;


   function applyTransform() {
     const scale = zoomed ? 2 : 1;
     imgEl.style.transform = `scale(${scale}) translate(${translateX}px, ${translateY}px)`;
   }


   zoomBtn.onclick = () => {
     zoomed = !zoomed;
     translateX = 0;
     translateY = 0;
     applyTransform();
     imgEl.style.cursor = zoomed ? 'grab' : 'zoom-in';
   };


   imgEl.onclick = (e) => {
     if (!isDragging) zoomBtn.click();
   };


   imgEl.addEventListener('mousedown', (e) => {
     if (!zoomed) return;
     isDragging = false;
     dragStartX = e.clientX - translateX;
     dragStartY = e.clientY - translateY;
     imgEl.style.cursor = 'grabbing';
     e.preventDefault();


     function onMove(e) {
       isDragging = true;
       translateX = e.clientX - dragStartX;
       translateY = e.clientY - dragStartY;
       applyTransform();
     }


     function onUp() {
       imgEl.style.cursor = 'grab';
       document.removeEventListener('mousemove', onMove);
       document.removeEventListener('mouseup', onUp);
       setTimeout(() => { isDragging = false; }, 10);
     }


     document.addEventListener('mousemove', onMove);
     document.addEventListener('mouseup', onUp);
   });




   let touchStartX = 0;
   lb.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; });
   lb.addEventListener('touchend', e => {
     const diff = touchStartX - e.changedTouches[0].clientX;
     if (Math.abs(diff) > 50) diff > 0 ? show(current + 1) : show(current - 1);
   });


   document.addEventListener('keydown', function handler(e) {
     if (e.key === 'ArrowLeft') show(current - 1);
     if (e.key === 'ArrowRight') show(current + 1);
     if (e.key === 'Escape') { close(); document.removeEventListener('keydown', handler); }
   });


   show(current);
 }


 document.addEventListener('click', function (e) {
   const trigger = e.target.closest('.product__media-toggle, .product__media-zoom-lightbox, .product__media-item img');
   if (!trigger) return;
   e.preventDefault();
   e.stopImmediatePropagation();
   const mediaItem = trigger.closest('.product__media-item');
   const allItems = Array.from(document.querySelectorAll('.product__media-item:not(.product__media-item--variant)'));
   const idx = allItems.indexOf(mediaItem);
   openLightbox(idx > -1 ? idx : 0);
 }, true);


});



